
import { useState,useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";

// @mui material components

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import AuthenticationLayout from "../components/AuthenticationLayout";
// Images
import model from "assets/images/change.png";
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const SERVER_URL 	= process.env.REACT_APP_API_URL; 
const API_TOKEN  = process.env.REACT_APP_API_TOKEN
function ConfirmPassword() {
  const navigate=useNavigate()
  const [rememberMe, setRememberMe] = useState(true);
  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const[password,setPassword]=useState("")
  const [confirmPass,setConfirmPass] = useState("")
  const [urltoken,setToken] = useState("")
  const [email,setEmail] = useState("")
  const [error,setError] = useState("")
  const [passError,setPassError] = useState("")


  const handleUsernameChange=(event)=>{
    if(event?.target?.value.length < 8 && event?.target?.value.length !=0){
      setError("Password should be atleast 8 characters")
    }else{
      setError("")
    }
    setPassword(event.target.value)
        
  }


  const handlePasswordChange=(event)=>{
    if(event.target.value != password && event.target.value.length != 0 ){
      setPassError("Passwords must match")
    }else{
      setPassError("")
    }
    setConfirmPass(event.target.value)
  }

  
  const location = useLocation();

  useEffect(() => {
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get('token');
      if (token){
        verifyToken(token)
      }
  }, []);

  const verifyToken = async (token) => {
    try {
        const response = await axios.get(`${SERVER_URL}verify-token`, {
            params: {
                token: token // Assuming Urltoken is defined elsewhere
            },
            headers: {
                "api-token": API_TOKEN
            }
        });
        if (response.status === 200) {
            // If verification is successful
           setEmail(response?.data?.data?.email); 
           setToken(response?.data?.data?.token);
        } else {
            console.error("Try again:", response.data.message);
            // Alert or handle the error message
        }
    } catch (error) {
        console.error("An error occurred:", error);
        // Handle the error (e.g., show error message to the user)
    }
};

const handleSubmit = async (event) => {
  event.preventDefault(); 

  if (confirmPass === '' || password === '') {
      console.error("Input fields cannot be empty");
      return;
  }
  try {
      const response = await axios.get(`${SERVER_URL}reset-password`, {
          params: {
              token: urltoken,
              email: email,
              password: password,
              password_confirmation: confirmPass
          },
          headers: {
              "api-token": API_TOKEN
          }
      });
      if (response.status === 200) {
          // If password reset is successful
          toast.success(response?.data?.message);
          setTimeout(() => {
          navigate('/login');
          },1000)
      } else {
        toast.error(response?.data?.message);
          console.error("Please enter correct credentials");
      }
  } catch (error) {
    toast.error(error?.response?.data?.message);
      console.error("An error occurred:", error);
  }
};

  return (
    <AuthenticationLayout
      title="Welcome To Telsim Retailer Portal"
      description="Enter your email to change your password"
      image={model}
    >
      <ToastContainer hideProgressBar={false} position="top-right" autoClose={1000} />
      <SoftBox component="form" role="form" onSubmit={handleSubmit}>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
              Enter Your password
            </SoftTypography>
          </SoftBox>
          <SoftInput type="password" placeholder="Password"  value={password} onChange={handleUsernameChange} error={error}/>
                    <SoftTypography variant="caption" color="error">{error}</SoftTypography>
        </SoftBox>
        <SoftBox mb={2}>
          <SoftBox mb={1} ml={0.5}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
            Confirm your Password
            </SoftTypography>
          </SoftBox>
          <SoftInput type="password" placeholder="Confirm-Password"  value={confirmPass} onChange={handlePasswordChange}/>
          <SoftTypography variant="caption" color="error">{passError}</SoftTypography>
        </SoftBox>
        {/* <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Remember me
          </SoftTypography>
        </SoftBox> */}
        <SoftBox mt={4} mb={1}>
          <SoftButton variant="gradient" color="primary" fullWidth   onClick={handleSubmit}>
             Submit
          </SoftButton>
        </SoftBox>
        {/* <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Don&apos;t  know your password?{" "}
            <SoftTypography
              component={Link}
              to="/authentication/sign-up"
              variant="button"
              color="primary"
              fontWeight="medium"
              textGradient
            >
              Forgot Password
            </SoftTypography>
          </SoftTypography>
        </SoftBox> */}
      </SoftBox>
    </AuthenticationLayout>
  );
}

export default ConfirmPassword;